export function TextField(props: {
  type?: string;
  label: string;
  value: string;
  setValue: (value: string) => void;
}) {
  const { label, value, setValue, type = "text" } = props;
  return (
    <div className="flex flex-grow flex-col gap-1">
      <label>{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={`dynamic-focus-border resize-none rounded-md border p-1`}
      />
    </div>
  );
}
